export const VARIABLES_LOADING = 'VARIABLES_LOADING';
export const VARIABLES_LOAD_VARIABLETYPE = 'VARIABLES_LOAD_VARIABLETYPE';
export const VARIABLES_LOAD_VARIABLESUBTYPE = 'VARIABLES_LOAD_VARIABLESUBTYPE';
export const VARIABLES_LOAD_QUALIFIER = 'VARIABLES_LOAD_QUALIFIER';
export const VARIABLES_LOAD_UNIT = 'VARIABLES_LOAD_UNIT';
export const VARIABLES_LOAD_ERROR = 'VARIABLES_LOAD_ERROR';